(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('EditPollsController', EditPollsController);
      
  EditPollsController.$inject = [
    '$log', 
    '$anchorScroll',
    '$mdDialog',
    '$mdToast',
    '$scope', 
    '$state', 
    '$stateParams',
    'clipboard', 
    'inflector',
    'shell', 
    'myPollsService'
  ];
    
  function EditPollsController(
      $log, 
      $anchorScroll,
      $mdDialog,
      $mdToast,
      $scope, 
      $state, 
      $stateParams,
      clipboard, 
      inflector,
      shell, 
      myPollsService
    ) {
    $log = $log.getInstance('EditPollsController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.activating = false;
    vm.addPoll = addPoll;
    vm.canCopyToClipboard = canCopyToClipboard;
    vm.copyToClipboard = copyToClipboard;
    vm.deletePoll = deletePoll;
    vm.group = null;
    vm.inflector = inflector;
    vm.isSaving = false;
    vm.pollEditTemplate = pollEditTemplate;
    vm.reorderPoll = reorderPoll;
    
    activate();
    
    function activate() {      
      myPollsService.getGroup(
        $stateParams.collectionId, 
        $stateParams.groupId
      ).then(function(group){
        _setGroup(group)
        if ($stateParams.jumpToAddPoll) addPoll()
      });
      
      $anchorScroll('top');
    }
    
    function addPoll() {
      $mdDialog.show({
        fullscreen: true,
        templateUrl: 'app/my-polls/collections/add-poll.html',
        controller: 'AddPollController as vm',
        clickOutsideToClose: true,
        locals: { group: vm.group }
      }).finally(function() {
        // Set the group again so that changes are reflected in vm.
        _setGroup(vm.group);
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
    }
    
    function canCopyToClipboard(poll) {
      return angular.isFunction(poll.toPlainText);
    }
    
    function copyToClipboard(poll) {
      if (!canCopyToClipboard(poll))
        return;
      var header = 'MARS Poll: ' + inflector.humanize(poll.type) + '\n\n';
      clipboard.copyText(header + poll.toPlainText());
    }
    
    function deletePoll(index) {
      var poll = vm.polls[index];
      vm.polls.splice(index, 1);
      myPollsService.deletePoll(poll, poll._isNew);
      $mdToast.show($mdToast.simple()
        .textContent('Poll Sent to Trash')
        .action('UNDO')
        .highlightAction(true)
        .position('bottom right')
      ).then(function(response) {
        if ( response === 'ok' ) {
          vm.polls.splice(index, 0, poll);
          myPollsService.restorePoll(poll);
        }
      });
    }

    function pollEditTemplate(poll) {
      return 'plugins/' + poll.type + '/' + poll.type + '.poll.edit.html';
    }
    
    function reorderPoll(fromIndex, toIndex) {
      if (toIndex < 0 || toIndex >= vm.polls.length)
        return;
      var poll1 = vm.polls[fromIndex],
          poll2 = vm.polls[toIndex];
      myPollsService.swapPolls(poll1, poll2);
      vm.polls[fromIndex] = poll2;
      vm.polls[toIndex] = poll1;
      $anchorScroll('poll-' + toIndex);
    }
    
    function _setGroup(group) {
      vm.group = group;
      vm.polls = _.filter(group.polls, function(poll) {
        return !angular.isDate(poll.deleted);
      });
      shell.setTitle(group.collection.name + ' - ' + group.name);
      shell.setBack(
        'shell.myPolls.collections.viewCollection', 
        { collectionId: group.collection._id }
      );
      vm.activating = false;
    }
    
  }
  
})();